export default {
  data() {
    return {
      rules: {
        required: (v) => (v !== undefined && v !== null && (v + '').length > 0) || '必填',
        name: (v) => !v || /.{2,}/.test(v) || '2个字以上',
        // eslint-disable-next-line
        email: (v) => !v || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email格式错误',
        password: (v) => !v || /^([^ ]{6,})$/.test(v) || '长度至少6位，不能包含空格',
        mobile: (v) => !v || /^1\d{10}$/.test(v) || '手机号格式不正确',
        number: (v) => !v || (/^[1-9][0-9]{0,}$/.test(v) && /[^0-9]/.test(v) === false) || '格式不正确，必须为整数',
        biggerthan0: (v) => !v || parseFloat(v) > 0 || '必须大于0'
      }
    }
  }
}
